/**
 * 编辑菜单
 */
import React from 'react';
import { Modal, Input, Form, Select, message, Radio } from 'antd';
import PropTypes from 'prop-types';
import styles from './EditModal.module.scss';
import http from '@/assets/api/http';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const { Option } = Select;

class EditModal extends React.Component {

    formRef = React.createRef();
    state = {
        confirmLoading: false,
    }

    componentDidMount() {
        const { menuType, menuName, menuUrl, menuCode } = this.props.openModeParam;
        this.formRef.current.setFieldsValue({ menuType });
        this.formRef.current.setFieldsValue({ menuName });
        this.formRef.current.setFieldsValue({ menuUrl });
        this.formRef.current.setFieldsValue({ menuCode });
    }

    // 确认
    _handleOk = () => {
        this.formRef.current.validateFields().then((fieldsValue) => {
            const { id } = this.props.openModeParam;
            const data = { ...fieldsValue, id };
            data.menuName = data.menuName.trim();
            data.menuUrl = data.menuUrl.trim();
            data.menuCode = data.menuCode.trim();
            http('/?cmd=com.xqxc.api.pig.mis.biz.account.MenuMisService.updateMenuInfo', data, 'POST').then(() => {
                message.success('编辑成功！');
                this.props.closeModal(true);
            }).catch((e) => {
                message.error(e.message);
            });
        });
    }

    // 取消
    _handleCancel = () => {
        this.props.closeModal();
    }

    // 渲染父级菜单下拉列
    _renderSelect = (list) => {
        return list.map((item) => {
            return <Option key={item.id} value={item.id}>{item.menuName}</Option>;
        });
    }

    render() {
        const { confirmLoading } = this.state;

        return (
            <Modal
                width={900}
                centered
                title='编辑菜单'
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Form
                        {...formItemLayout}
                        ref={this.formRef}
                        initialValues={{}}
                        scrollToFirstError
                    >
                        <Form.Item
                            label="菜单类型"
                            name="menuType"
                            rules={[]}>
                            <Radio.Group disabled onChange={this._menuTypeChange}>
                                <Radio key={0} value={'ONE_LEVEL'}>一级目录</Radio>
                                <Radio key={1} value={'TWO_LEVEL'}>二级菜单</Radio>
                                <Radio key={2} value={'THREE_LEVEL'}>三级菜单</Radio>
                                <Radio key={3} value={'TAB_PAGE'}>Tab标签页</Radio>
                                <Radio key={4} value={'BUTTON'}>按钮</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            label="菜单名称"
                            name="menuName"
                            rules={[
                                { required: true },
                                { max: 20, message: '最多可输入20个字' },
                            ]}>
                            <Input placeholder='请输入菜单名称' />
                        </Form.Item>
                        <Form.Item
                            label="URL"
                            name="menuUrl"
                            rules={[
                                { required: true }
                            ]}>
                            <Input placeholder='请输入URL地址' />
                        </Form.Item>
                        <Form.Item
                            label="编号"
                            name="menuCode"
                            rules={[
                                { required: true }
                            ]}>
                            <Input placeholder='请输入菜单编号' />
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        );

    }
}

EditModal.propTypes = {
    openModeParam: PropTypes.object, // 菜单详情
    systemType: PropTypes.string, // 后台类型
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
};

export default EditModal;

